(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('updateTargetsService', updateTargetsService);

	updateTargetsService.$inject = ['$http', '$rootScope', '$filter', '$uibModal', 'leanFilterService', 'currencyFormatService', 'percentageFormatService', 'numberFormatService'];

	function updateTargetsService($http, $rootScope, $filter, $uibModal, leanFilterService, currencyFormatService, percentageFormatService, numberFormatService) {
		var service = {
			saveData: saveData,
			organizeData: organizeData,
			getUpdatedCells: getUpdatedCells,
			copyMetricTargets: copyMetricTargets,
			getAllowedSites: getAllowedSites
		};
		return service;

		function saveData(data, siteId) {
			return $http.post('/api/2/factndx/' + siteId + '/UpdateTargets', data)
				.then(saveDataSuccess, saveDataError);

			function saveDataSuccess() {
				$rootScope.$emit('toast', {
					'message': 'Targets Saved',
					'success': true
				});
				return true;
			}

			function saveDataError() {
				$rootScope.$emit('toast', {
					'message': 'Error Saving Targets',
					'success': false
				});
				return false;
			}
		}

		function organizeData(data) {
			var dataset = {
				'initialData': {},
				'metricConfigByNdx': {},
				'metricNoOfWeeks': {}
			};

			for (var i = 0; i < data.length; i++) {
				var row = data[i];
				dataset.initialData[row.metric.ndx] = {};
				dataset.metricConfigByNdx[row.metric.ndx] = {};
				dataset.metricNoOfWeeks[row.metric.ndx] = {};
				dataset.initialData[row.metric.ndx].goalType = row.metric.goalType;
				for (var j = 0; j < row.results.length; j++) {
					var month = row.results[j];
					dataset.initialData[row.metric.ndx][month.fiscalPeriod] = {
						target: month.target,
						targetValueA: month.targetValueA,
						targetValueB: month.targetValueB
					};
					dataset.metricNoOfWeeks[row.metric.ndx][month.fiscalPeriod] = month.noOfWeeks;
				}
				row.metric['isCalculated'] = false;
				if (row.metric.analyticsValueFunction && row.metric.analyticsValueFunction !== 'value' &&
				row.metric.analyticsValueFunction.startsWith('{') &&
				row.metric.analyticsValueFunction.endsWith('}')) {

					var jsonBlob = JSON.parse(row.metric.analyticsValueFunction);
					if (jsonBlob.targets && jsonBlob.targets === 'calculated') {
						row.metric['isCalculated'] = true;
					}
				}

				dataset.metricConfigByNdx[row.metric.ndx]['displayType'] = row.metric['displayType'];
				dataset.metricConfigByNdx[row.metric.ndx]['isCalculated'] = row.metric['isCalculated'];
				dataset.metricConfigByNdx[row.metric.ndx]['isRatio'] = row.metric['targetValueFunction'] === 'valueA/valueB';
			}
			return dataset;
		}

		function getFormattedValue(rawValue, displayType) {
			var formattedValue = '';
			switch (displayType) {
			case 'currency':
				formattedValue = currencyFormatService.getWithParameters(rawValue, numberOfDecimals(rawValue), globalConfig.browser.currencySymbol);
				break;
			case 'percentage':
				formattedValue = percentageFormatService.getWithParameters(rawValue);
				break;
			default:
				formattedValue = $filter('number')(rawValue);
			}
			return formattedValue;
		}
	
		function getRatioPercentValue(isRatio, displayType) {
			return isRatio && displayType ? 100 : 1;
		}
	
		function getUpdatedCells(initialData, metricConfigByNdx, metricNoOfWeeks, periods, isWeekly) {
			var cellsUpdated = [];
			var periodKey = isWeekly ? 'week' : 'month';
			var targetPeriodType = isWeekly ? 'Weekly' : 'Monthly';
			jQuery('.update-targets-cell .targetDiv input.firstValue').each(function () {
				var meta = this.id.split('-');
				var metric = meta[0].substring(6);
				var period = meta[1].substring(5);
				var isRatio = metricConfigByNdx[metric]['isRatio'];
				var valueAInput = this.value;
				var valueBInput = jQuery('#' + this.id + '-B').val();
				var userValue = parseFloat(numberFormatService.getOriginalNumber(valueAInput));
				var userValueB = isRatio ? parseFloat(numberFormatService.getOriginalNumber(valueBInput)) : null;

				if (userValue === NaN && valueAInput.trim() !== '' || (isRatio && valueBInput.trim() !== '' && userValueB === NaN)) {
					$rootScope.$emit('toast', {
						'message': 'Input not recognized as a valid number',
						'success': false
					});
					return;
				}
				var initialValue = parseFloat(initialData[metric][period].target);
				var initialValueA = parseFloat(initialData[metric][period].targetValueA);
				var initialValueB = parseFloat(initialData[metric][period].targetValueB);
				var displayType = metricConfigByNdx[metric]['displayType'];

				if (!metricConfigByNdx[parseInt(metric)]['isCalculated']) {
					var isValid = false;
					var isValueANull = isNaN(userValue);
					var isValueBNull = isNaN(userValueB);

					if (isRatio) {
					// Check if has valid valueA
						var hasValidA = false;
						var hasValidB = false;
						var valueAChanged = userValue !== initialValueA;
						var valueBChanged = userValueB !== initialValueB;
						if (!(isNaN(userValue) && isNaN(initialValueA))) {
							hasValidA = true;
						}
						if (!(isNaN(userValueB) && isNaN(initialValueB)) && userValueB !== 0) {
							hasValidB = true;
						}
						isValid = (valueAChanged || valueBChanged) && (hasValidA && hasValidB) && (isValueANull === isValueBNull);
					} else {
						if ((userValue !== initialValue) && !(isNaN(userValue) && isNaN(initialValue))) {
							isValid = true;
						}
					}
					if (isValid) {
						var target = isRatio ? (!isValueANull && !isValueBNull) ? parseFloat(userValue) / parseFloat(userValueB) : null : userValue;
						initialData[metric][period]['target'] = userValue; // update the entry with the latest change
						if (isRatio) {
							initialData[metric][period]['targetValueA'] = userValue;
							initialData[metric][period]['targetValueB'] = userValueB;
						}

						var tdElement = jQuery(this).closest('.targetDiv');
						if (metricNoOfWeeks[metric][period]) {
							tdElement.attr('title', 'Monthly target: ' + (isNaN(target) ? null :
								parseFloat(target) * metricNoOfWeeks[metric][period] * getRatioPercentValue(isRatio, displayType)));
						} else {
							if (target) {
								tdElement.attr('title', 'Target = ' + getFormattedValue(parseFloat(target) * getRatioPercentValue(isRatio, displayType), metricConfigByNdx[metric]['displayType']));
							} else {
								tdElement.attr('title', '');
							}

						}

						var cell = {};
						cell['metricNdx'] = parseInt(metric);
						cell[periodKey] = parseInt(period);
						cell['year'] = periods[periodKey + (parseInt(period) - 1)].year;
						cell['valueStreamNdx'] = parseInt(initialData.valueStreamWithPerf);
						cell['value'] = userValue;
						cell['targetPeriodType'] = targetPeriodType;
						if (isRatio) {
							cell['valueA'] = isValueANull ? null : userValue;
							cell['valueB'] = isValueBNull ? null : userValueB;
						}
						cell['hasRatio'] = isRatio;
						cellsUpdated.push(cell);
					}
				}
			});
			return cellsUpdated;
		}

		function copyMetricTargets(scope, metricName, metricNdx, periodType, isRatioTarget, metricConfigByNdx, defaultYear, isWeekly) {
			if (!metricConfigByNdx[metricNdx]['isCalculated']) {
				var copyModalScope = scope.$new();
				copyModalScope.metricName = metricName;
				var year = leanFilterService.getSelectedIds('fy')[0];
				if (year === undefined) {
					year = defaultYear;
				}
				copyModalScope.periodType = periodType;
				copyModalScope.fiscalYear = year;
				copyModalScope.isRatioTarget = isRatioTarget;
				copyModalScope.data = {
					copyValue: '',
					copyValueB: ''
				};
				var instance = $uibModal.open({
					scope: copyModalScope,
					templateUrl: '/application/f/setup/metricsAndGoals/updateTargets/templates/copy-row.html',
					windowClass: 'target-copy'
				});

				copyModalScope.cancel = function () {
					instance.close();
					copyModalScope.$destroy();
				};

				copyModalScope.ok = function () {
					var metricNdxId = 'metric' + metricNdx;
					var value = parseFloat(copyModalScope.data.copyValue.replace(/,/g, ''));
					var valueB = parseFloat(copyModalScope.data.copyValueB.replace(/,/g, ''));
					if (isNaN(value) || (isRatioTarget && (isNaN(valueB) || valueB === 0))) {
						value = '';
						valueB = '';
						$rootScope.$emit('toast', {
							'message': 'Input not recognized as a number',
							'success': false
						});
					} else {
						var noOfPeriods = isWeekly ? 54 : 13;
						for (var i = 1; i < noOfPeriods; i++) {
							if (isRatioTarget) {
								jQuery('#' + metricNdxId + '-month' + i).val(value);
								jQuery('#' + metricNdxId + '-month' + i + '-B').val(valueB);
							} else {
								jQuery('#' + metricNdxId + '-month' + i).val(value);
							}
						}
					}

					instance.close();
					copyModalScope.$destroy();
				};
			}
		}

		function getAllowedSites() {
			var factories = _.toArray(globalConfig.user.authFacts).filter(function (factory) {
				return factory.customerNdx === globalConfig.customer.id && (factory.profileType === 'SystemAdministrator' || factory.profileType === 'SuperSystemAdministrator' || factory.canEditAnyMetricTargets);
			});

			var objectList = factories.map(function (factory) {
				return {
					id: factory.ndx,
					name: factory.name,
					alias: factory.alias || factory.name,
					businessunit: factory.businessunit,
					division: factory.division,
					entity: factory.entity,
					dataSyncIssue: factory.dataSyncIssue
				};
			}).sort(function (a, b) {
				if (a.alias < b.alias)
					return -1;
				if (a.alias > b.alias)
					return 1;
				return 0;
			});
			return objectList;
		}
	}
})();
